import { Link } from 'react-router-dom';
import { Radio, Bot } from 'lucide-react';
import { cn } from '@reflex/ui/lib/utils';
import { statusTintChip } from '@/components/shared/status-tint-chip';
import { truncateId } from '@reflex/ui/lib/format';
import { useActiveOrgSlug, useOrgRoutes } from '@/lib/useOrgRoutes';
import { withOrgSlug } from '@/lib/routes';

type ResourceType = 'axon' | 'run';

const resourceMeta: Record<
  ResourceType,
  {
    icon: typeof Radio;
    label: string;
    color: string;
    tone: 'info' | 'success';
  }
> = {
  axon: {
    icon: Radio,
    label: 'Axon Stream',
    color: 'text-status-info',
    tone: 'info',
  },
  run: {
    icon: Bot,
    label: 'Run',
    color: 'text-status-success',
    tone: 'success',
  },
};

interface WorkflowResourceLinkProps {
  type: ResourceType;
  id: string;
  label?: string;
  className?: string;
}

export function WorkflowResourceLink({ type, id, label, className }: WorkflowResourceLinkProps) {
  const meta = resourceMeta[type];
  const Icon = meta.icon;
  const slug = useActiveOrgSlug();
  const routes = useOrgRoutes();
  const path = type === 'run' ? routes.agent(id) : withOrgSlug(slug, `/axons/${id}`);

  return (
    <Link
      to={path}
      title={`${meta.label}: ${id}`}
      className={cn(statusTintChip(meta.tone, 'md'), className)}
    >
      <Icon className={cn('h-3 w-3 shrink-0', meta.color)} />
      <span className="font-mono text-2xs">{label ?? truncateId(id)}</span>
    </Link>
  );
}
